import React, { PureComponent } from 'react';

import './LinkButton.scss';

export default class LinkButton extends PureComponent {
	handleClick = e => {
		e.preventDefault();
		if (this.props.onClick) {
			this.props.onClick(e);
		}
	};
	render() {
		const { children, classes, className, ...rest } = this.props;
		return (
			<button {...rest} className={`LinkButton ${classes} ${className}`} onClick={this.handleClick}>
				{children}
			</button>
		);
	}
}
